import React, { Component } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { GeneralVerify } from "./sopDataTemplate";
import Select from "react-select";

interface AllProps {
  data: GeneralVerify;
  handleGeneralVerifyChange: any;
  isOnlyView?: boolean;
}
export class GeneralVerification extends Component<AllProps> {
  state = {
    ownershipOptions: [
      { value: "Individual", label: "Individual" },
      { value: "Joint Ownership", label: "Joint Ownership" },
      { value: "Company", label: "Company" },
      { value: "Partnership", label: "Partnership" },
      { value: "Agri", label: "Agri" },
    ],
    natureofProperty: [
      { value: "Residential", label: "Residential" },
      { value: "Commercial", label: "Commercial" },
      { value: "Agri", label: "Agri" },
      { value: "Industrial", label: "Industrial" },
    ],
    freeRleasehold: [
      { value: "Freehold", label: "Freehold" },
      { value: "LeaseHold", label: "LeaseHold" },
    ],
    selectedOwnershipOption: null,
    isOptionOpen: false,
    bgColor: "#ffff8d",
  };

  changeBgColor = () => {
    const { bgColor } = this.state;
    if (bgColor !== "lightgreen") {
      this.setState({ bgColor: "lightgreen" });
    }
  };
  
  handleChange = (name, val) => {
    const { data } = this.props;

    // Special handling for fields that have value/verified structure
    if (name === "ownerShip" || name === "natureofProperty" || name === "freeRleasehold" || 
        name === "ownerAadharName" || name === "borrowerAadharName" || name === "coBorrowerAadharName" ||
        name === "addressofProperty" || name === "AppIdverfy") {
      if (typeof val === "object" && "verified" in val) {
        // When checkbox changes, val is {value, verified}
        data[name] = val;
      } else {
        // When select or input changes, val is just the string value
        // Maintain the existing verified status if it exists
        const existingVerified = data[name]?.verified || false;
        data[name] = { value: val, verified: existingVerified };
      }
    } else {
      data[name] = val;
    }

    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleGeneralVerifyChange(data);
  };
  
  handleStateChange = (stateName, value) => {
    console.log("value", value);
    this.setState(
      {
        [stateName]: value,
      },
      () => {
        this.changeBgColor();
      },
    );
  };
  
  handleFileChange = (name, val) => {
    const { data } = this.props;
    data.file[name] = val;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleGeneralVerifyChange(data);
  };

  getOtherProps = (key) => {
    const { isOnlyView } = this.props;
    if (isOnlyView) return { [key]: true };
    return {};
  };

  // Helper function to get the select value - fixed version
  getSelectValue = (fieldName) => {
    const { data } = this.props;
    const fieldValue = data[fieldName];
    
    if (!fieldValue) return null;
    
    let stringValue = "";
    
    // Extract string value from the data structure
    if (typeof fieldValue === 'object' && fieldValue !== null) {
      // If it's an object with value property
      if (fieldValue.value !== undefined) {
        stringValue = fieldValue.value;
      } else {
        // If it's a string stored directly in the object
        stringValue = fieldValue;
      }
    } else {
      // If it's a plain string
      stringValue = fieldValue;
    }
    
    // Return null if no value
    if (!stringValue) return null;
    
    // Return the format React-Select expects
    return {
      value: stringValue,
      label: stringValue
    };
  };

  render() {
    const { data, isOnlyView } = this.props;
    const { selectedOwnershipOption, ownershipOptions, isOptionOpen, bgColor, natureofProperty, freeRleasehold } =
      this.state;
    
    return (
      <div className="collapse-section general-verification">
        <Accordion defaultActiveKey="0">
          <Card>
            <Accordion.Toggle
              style={{ background: data.bgColor ? data.bgColor : bgColor }}
              as={Card.Header}
              eventKey="0"
              onClick={() => {
                this.setState({ isOptionOpen: !isOptionOpen });
              }}
            >
              <h5>
                <b>General Verification</b>
              </h5>
              <i
                className={`icon feather icon-${
                  isOptionOpen ? "plus" : "minus"
                }`}
                style={{
                  color: "black",
                  fontSize: "17px",
                  fontWeight: "bold",
                  float: "right",
                }}
              />
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <div className="row mb-10">
                  <div className="col-md-12">
                    <label
                      className="label"
                      style={{ padding: 0, marginBottom: "8px" }}
                    >
                      Title Owner/ Property Owner Name Verified with Aadharcard
                      Name ?
                    </label>
                  </div>
                  <div className="col-md-12">
                    <div className="row align-items-center">
                      <div className="col-md-6 no-padding">
                        <input
                          type="text"
                          className="form-control"
                          value={data.ownerAadharName?.value || ""}
                          onChange={(e) =>
                            this.handleChange("ownerAadharName", {
                              value: e.target.value,
                              verified: data.ownerAadharName?.verified || false,
                            })
                          }
                          {...this.getOtherProps("disabled")}
                          placeholder="Enter name"
                        />
                      </div>
                      <div className="col-md-6 no-padding text-left">
                        <Form.Check
                          type="checkbox"
                          id="aadharVerified"
                          label=""
                          checked={data.ownerAadharName?.verified || false}
                          onChange={(e) =>
                            this.handleChange("ownerAadharName", {
                              value: data.ownerAadharName?.value || "",
                              verified: e.target.checked,
                            })
                          }
                          {...this.getOtherProps("disabled")}
                          style={{ marginLeft: "10px" }}
                          className="custom-large-checkbox"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-10">
                  <div className="col-md-12">
                    <label className="label" style={{ padding: 0 }}>
                      Borrower Name Verified with Aadharcard Name
                    </label>
                  </div>
                  <div className="col-md-12">
                    <div className="row align-items-center">
                      <div className="col-md-6 no-padding">
                        <input
                          type="text"
                          className="form-control"
                          value={data.borrowerAadharName?.value || ""}
                          onChange={(e) =>
                            this.handleChange("borrowerAadharName", {
                              value: e.target.value,
                              verified:
                                data.borrowerAadharName?.verified || false,
                            })
                          }
                          {...this.getOtherProps("disabled")}
                          placeholder="Enter name"
                        />
                      </div>
                      <div className="col-md-6 no-padding text-left">
                        <Form.Check
                          type="checkbox"
                          id="aadharVerified"
                          label=""
                          checked={data.borrowerAadharName?.verified || false}
                          onChange={(e) =>
                            this.handleChange("borrowerAadharName", {
                              value: data.borrowerAadharName?.value || "",
                              verified: e.target.checked,
                            })
                          }
                          {...this.getOtherProps("disabled")}
                          style={{ marginLeft: "10px" }}
                          className="custom-large-checkbox"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-10">
                  <div className="col-md-12 no-right-padding">
                    <label className="label" style={{ padding: 0 }}>
                      Co-Borrower Name / Co-Aplicant Name Verified with
                      AadharCard Name
                    </label>
                  </div>

                  <div className="col-md-12">
                    <div className="row align-items-center">
                      <div className="col-md-6 no-padding">
                        <input
                          type="text"
                          className="form-control"
                          value={data.coBorrowerAadharName?.value || ""}
                          onChange={(e) =>
                            this.handleChange("coBorrowerAadharName", {
                              value: e.target.value,
                              verified:
                                data.coBorrowerAadharName?.verified || false,
                            })
                          }
                          {...this.getOtherProps("disabled")}
                          placeholder="Enter name"
                        />
                      </div>
                      <div className="col-md-6 no-padding text-left">
                        <Form.Check
                          type="checkbox"
                          id="aadharVerified"
                          label=""
                          checked={data.coBorrowerAadharName?.verified || false}
                          onChange={(e) =>
                            this.handleChange("coBorrowerAadharName", {
                              value: data.coBorrowerAadharName?.value || "",
                              verified: e.target.checked,
                            })
                          }
                          {...this.getOtherProps("disabled")}
                          style={{ marginLeft: "10px" }}
                          className="custom-large-checkbox"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-10">
                  <div className="col-md-9 no-right-padding">
                    <label className="label" style={{ padding: 0 }}>
                      Is The Spelling for Mr./Smt/Minor/Late/ Initial Correct?
                    </label>
                  </div>
                  <div className="col-md-3 no-left-padding">
                    <div className="row">
                      <Form.Check
                        inline
                        label="Yes"
                        name="isSpellingCorrect"
                        type="radio"
                        id="spellTrue"
                        checked={data.isSpellingCorrect}
                        onChange={(e) =>
                          this.handleChange("isSpellingCorrect", true)
                        }
                        {...this.getOtherProps("disabled")}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name="isSpellingCorrect"
                        type="radio"
                        id="spellFalse"
                        checked={!data.isSpellingCorrect}
                        onChange={(e) =>
                          this.handleChange("isSpellingCorrect", false)
                        }
                        {...this.getOtherProps("disabled")}
                      />
                    </div>
                  </div>
                </div>
<div className="row mb-10">
  <div className="col-md-12">
    <label className="label" style={{ padding: 0 }}>
      Address of the Property - Hint about File Verified
    </label>
  </div>

  <div className="col-md-12">
    {/* Check the actual structure */}
    {(() => {
      // If addressofProperty has numeric keys like "9", "29" etc.
      const addressData = data.addressofProperty;
      
      if (addressData && typeof addressData === 'object') {
        // Get numeric keys only (exclude verified and value if they exist)
        const numericKeys = Object.keys(addressData).filter((key:any) => 
          !isNaN(key) || (key !== 'verified' && key !== 'value')
        );
        
        if (numericKeys.length > 0) {
          return numericKeys.map((key, index) => (
            <div className="row align-items-center mb-3" key={key}>
              <div className="col-md-6 no-padding">
                <input
                  type="text"
                  className="form-control"
                  value={addressData[key] || ""}
                  onChange={(e) => {
                    const updated = { ...addressData };
                    updated[key] = e.target.value;
                    this.handleChange("addressofProperty", updated);
                  }}
                  {...this.getOtherProps("disabled")}
                  placeholder={`Address line ${index + 1}`}
                />
              </div>
              {index === 0 && (
                <div className="col-md-6 no-padding text-left">
                  <Form.Check
                    type="checkbox"
                    id="addressVerified"
                    label=""
                    checked={addressData.verified || false}
                    onChange={(e) =>
                      this.handleChange("addressofProperty", {
                        ...addressData,
                        verified: e.target.checked,
                      })
                    }
                    {...this.getOtherProps("disabled")}
                    style={{ marginLeft: "10px" }}
                    className="custom-large-checkbox"
                  />
                </div>
              )}
            </div>
          ));
        }
      }
      
      // Default: show exactly 1 input field
      return (
        <div className="row align-items-center mb-3">
          <div className="col-md-6 no-padding">
            <input
              type="text"
              className="form-control"
              value=""
              onChange={(e) =>
                this.handleChange("addressofProperty", {
                  "1": e.target.value,
                  verified: false,
                })
              }
              {...this.getOtherProps("disabled")}
              placeholder="Enter address"
            />
          </div>
          <div className="col-md-6 no-padding text-left">
            <Form.Check
              type="checkbox"
              id="addressVerified"
              label=""
              checked={data.addressofProperty?.verified || false}
              onChange={(e) =>
                this.handleChange("addressofProperty", {
                  ...(data.addressofProperty || {}),
                  verified: e.target.checked,
                })
              }
              {...this.getOtherProps("disabled")}
              style={{ marginLeft: "10px" }}
              className="custom-large-checkbox"
            />
          </div>
        </div>
      );
    })()}
  </div>
</div>
                <div className="row mb-10">
                  <div className="col-md-12 no-right-padding">
                    <label className="label" style={{ padding: 0 }}>
                      Nature of the Property
                      (Residential/Commercial/Agri/Industrial)
                    </label>
                  </div>
                  <div className="col-md-12">
                    <div className="row align-items-center">
                      <div className="col-md-6 no-padding">
                        <Select
                          value={this.getSelectValue("natureofProperty")}
                          onChange={(value) =>
                            this.handleChange("natureofProperty", value.value)
                          }
                          options={natureofProperty}
                          className="select-dropdown"
                          style={{ minWidth: "400px" }}
                          {...this.getOtherProps("isDisabled")}
                        />
                      </div>
                      <div className="col-md-6 no-padding text-left">
                        <Form.Check
                          type="checkbox"
                          id="natureofPropertyVerified"
                          label=""
                          checked={data.natureofProperty?.verified || false}
                          onChange={(e) =>
                            this.handleChange("natureofProperty", {
                              value: data.natureofProperty?.value || "",
                              verified: e.target.checked,
                            })
                          }
                          {...this.getOtherProps("disabled")}
                          style={{ marginLeft: "10px" }}
                          className="custom-large-checkbox"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-10">
                  <div className="col-md-12">
                    <label className="label" style={{ padding: 0 }}>
                      APP ID Verified
                    </label>
                  </div>
                  <div className="col-md-12">
                    <div className="row align-items-center">
                      <div className="col-md-6 no-padding">
                        <input
                          type="text"
                          className="form-control"
                          value={data.AppIdverfy?.value || ""}
                          onChange={(e) =>
                            this.handleChange("AppIdverfy", {
                              value: e.target.value,
                              verified: data.AppIdverfy?.verified || false,
                            })
                          }
                          {...this.getOtherProps("disabled")}
                          placeholder="Enter name"
                        />
                      </div>
                      <div className="col-md-6 no-padding text-left">
                        <Form.Check
                          type="checkbox"
                          id="aadharVerified"
                          label=""
                          checked={data.AppIdverfy?.verified || false}
                          onChange={(e) =>
                            this.handleChange("AppIdverfy", {
                              value: data.AppIdverfy?.value || "",
                              verified: e.target.checked,
                            })
                          }
                          {...this.getOtherProps("disabled")}
                          style={{ marginLeft: "10px" }}
                          className="custom-large-checkbox"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-10">
                  <div className="col-md-12">
                    <label className="label" style={{ padding: 0 }}>
                      Constitution
                    </label>
                  </div>
                  <div className="col-md-12">
                    <div className="row ml-10 align-items-center">
                      <div className="col-6">
                        <Select
                          value={this.getSelectValue("ownerShip")}
                          onChange={(value) =>
                            this.handleChange("ownerShip", value.value)
                          }
                          options={ownershipOptions}
                          className="select-dropdown"
                          style={{ minWidth: "400px" }}
                          {...this.getOtherProps("isDisabled")}
                        />
                      </div>
                      <div className="col-6 text-left">
                        <Form.Check
                          type="checkbox"
                          id="ownerShipVerified"
                          checked={data.ownerShip?.verified || false}
                          onChange={(e) =>
                            this.handleChange("ownerShip", {
                              value: data.ownerShip?.value || "",
                              verified: e.target.checked,
                            })
                          }
                          {...this.getOtherProps("disabled")}
                          className="custom-large-checkbox d-flex align-items-center"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-10">
                  <div className="col-md-9 no-right-padding">
                    <label className="label" style={{ padding: 0 }}>
                      Hint About File Verified
                    </label>
                  </div>
                  <div className="col-md-3 no-left-padding">
                    <div className="row">
                      <Form.Check
                        inline
                        label="Yes"
                        name="hintAbtfile"
                        type="radio"
                        id="spellTrue"
                        checked={data.hintAbtfile}
                        onChange={(e) => this.handleChange("hintAbtfile", true)}
                        {...this.getOtherProps("disabled")}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name="hintAbtfile"
                        type="radio"
                        id="spellFalse"
                        checked={!data.hintAbtfile}
                        onChange={(e) =>
                          this.handleChange("hintAbtfile", false)
                        }
                        {...this.getOtherProps("disabled")}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mb-10">
                  <div className="col-md-12 no-right-padding">
                    <label className="label" style={{ padding: 0 }}>
                      Freehold/ LeaseHold
                    </label>
                  </div>
                  <div className="col-md-12">
                    <div className="row align-items-center">
                      <div className="col-6">
                        <Select
                          value={this.getSelectValue("freeRleasehold")}
                          onChange={(value) =>
                            this.handleChange("freeRleasehold", value.value)
                          }
                          options={freeRleasehold}
                          className="select-dropdown"
                          style={{ minWidth: "400px" }}
                          {...this.getOtherProps("isDisabled")}
                        />
                      </div>
                      <div className="col-md-6 no-padding text-left">
                        <Form.Check
                          type="checkbox"
                          id="freeRleaseholdVerified"
                          label=""
                          checked={data.freeRleasehold?.verified || false}
                          onChange={(e) =>
                            this.handleChange("freeRleasehold", {
                              value: data.freeRleasehold?.value || "",
                              verified: e.target.checked,
                            })
                          }
                          {...this.getOtherProps("disabled")}
                          style={{ marginLeft: "10px" }}
                          className="custom-large-checkbox"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <hr />
                <div>
                  <h6>
                    <b>File</b>
                  </h6>
                  <div className="row mb-10">
                    <div className="col-md-3 mb-10">
                      <label className="label mb-2" style={{ padding: 0 }}>
                        BT Transfer
                      </label>
                      {data.file.btTransfer}
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="btTransfer"
                          type="radio"
                          checked={data.file.btTransfer}
                          onChange={(e) =>
                            this.handleFileChange("btTransfer", true)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="btTransfer"
                          type="radio"
                          checked={!data.file.btTransfer}
                          onChange={(e) =>
                            this.handleFileChange("btTransfer", false)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-10">
                      <label className="label" style={{ padding: 0 }}>
                        MOD Available
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="modAvailable"
                          type="radio"
                          checked={data.file.modAvailable}
                          onChange={(e) =>
                            this.handleFileChange("modAvailable", true)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="modAvailable"
                          type="radio"
                          checked={!data.file.modAvailable}
                          onChange={(e) =>
                            this.handleFileChange("modAvailable", false)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-10">
                      <label className="label" style={{ padding: 0 }}>
                        Predisbursement Verified
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="preDisbursmentverfy"
                          type="radio"
                          checked={data.file?.preDisbursmentverfy}
                          onChange={(e) =>
                            this.handleFileChange("preDisbursmentverfy", true)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="preDisbursmentverfy"
                          type="radio"
                          checked={!data.file?.preDisbursmentverfy}
                          onChange={(e) =>
                            this.handleFileChange("preDisbursmentverfy", false)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-10">
                      <label className="label" style={{ padding: 0 }}>
                        Purchase
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="purchase"
                          type="radio"
                          checked={data.file.purchase}
                          onChange={(e) =>
                            this.handleFileChange("purchase", true)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="purchase"
                          type="radio"
                          checked={!data.file.purchase}
                          onChange={(e) =>
                            this.handleFileChange("purchase", false)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label className="label" style={{ padding: 0 }}>
                        Sale Agreement
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="saleAgreement"
                          type="radio"
                          checked={data.file.saleAgreement}
                          onChange={(e) =>
                            this.handleFileChange("saleAgreement", true)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="saleAgreement"
                          type="radio"
                          checked={!data.file.saleAgreement}
                          onChange={(e) =>
                            this.handleFileChange("saleAgreement", false)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label className="label" style={{ padding: 0 }}>
                        Post Disbursement Verified
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="postDisbursverfy"
                          type="radio"
                          checked={data.file?.postDisbursverfy}
                          onChange={(e) =>
                            this.handleFileChange("postDisbursverfy", true)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="postDisbursverfy"
                          type="radio"
                          checked={!data.file?.postDisbursverfy}
                          onChange={(e) =>
                            this.handleFileChange("postDisbursverfy", false)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label className="label" style={{ padding: 0 }}>
                        New Building / Construction/Self Construction
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="selfConstruction"
                          type="radio"
                          checked={data.file.selfConstruction}
                          onChange={(e) =>
                            this.handleFileChange("selfConstruction", true)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="selfConstruction"
                          type="radio"
                          checked={!data.file.selfConstruction}
                          onChange={(e) =>
                            this.handleFileChange("selfConstruction", false)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                      </div>
                    </div>
                    <div className="col-md-7 no-left-padding">
                      <label className="label" style={{ padding: 0 }}>
                        Proceeding Approval/Approved Plan
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="proceedingApproval"
                          type="radio"
                          checked={data.file.proceedingApproval}
                          onChange={(e) =>
                            this.handleFileChange("proceedingApproval", true)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="proceedingApproval"
                          type="radio"
                          checked={!data.file.proceedingApproval}
                          onChange={(e) =>
                            this.handleFileChange("proceedingApproval", false)
                          }
                          {...this.getOtherProps("disabled")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label className="label" style={{ padding: 0 }}>
                      Fresh Case
                    </label>
                    <div className="row" style={{ marginLeft: 0 }}>
                      <Form.Check
                        inline
                        label="Yes"
                        name="new"
                        type="radio"
                        checked={data.file.new}
                        onChange={(e) => this.handleFileChange("new", true)}
                        {...this.getOtherProps("disabled")}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name="new"
                        type="radio"
                        checked={!data.file.new}
                        onChange={(e) => this.handleFileChange("new", false)}
                        {...this.getOtherProps("disabled")}
                      />
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}

export default GeneralVerification;